import TableHeaderCell from './TableHeaderCell'
export default TableHeaderCell
